import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-multi-selection-toolbar',
  templateUrl: './multi-selection-toolbar.component.html',
  styleUrls: ['./multi-selection-toolbar.component.scss'],
  standalone: true
})
export class MultiSelectionToolbarComponent {
  onClose = output();
  isOpen = input<boolean>(false);
  label = input<string>();
}
